import script from "./pop-up-confirm-evaluation.vue?vue&type=script&setup=true&lang=js"
export * from "./pop-up-confirm-evaluation.vue?vue&type=script&setup=true&lang=js"

import "./pop-up-confirm-evaluation.vue?vue&type=style&index=0&id=85acbf14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85acbf14"]])

export default __exports__